import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import {AppStateProvider} from './AppState';

type Props = {
  children: React.ReactNode
}

const AppWrappers = ({children}: Props) => (
  <BrowserRouter>
    <AppStateProvider>
      {children}
    </AppStateProvider>
  </BrowserRouter>
);

export default AppWrappers;